import PersonaPage from "./PersonaPage";

const questions = [
  { q: "Wer war sie für Sie?", why: "Mutter, Schwester, Tochter, Ehefrau, Freundin — die Beziehung trägt den Ton." },
  { q: "Wie war ihre Art?", why: "Warm oder klar, laut oder still, weich oder resolut — daraus entsteht ihre Stimme im Text." },
  { q: "Was war ihr wichtig?", why: "Familie, ein Beruf, ein Garten, eine Musik — das Wesentliche ihres Lebens wird zum Rahmen." },
  { q: "Eine Erinnerung, die bleibt.", why: "Ein Rezept, ein Lied, ein Blick — das kleine, konkrete Bild macht eine Rede persönlich." },
  { q: "Was hat sie hinterlassen?", why: "Sätze, Rituale, eine Art zu trösten. Nicht die Dinge — die Spuren in Menschen." },
  { q: "Wie soll die Rede klingen?", why: "Getragen, warm, mit einem stillen Lächeln — Sie geben den Ton, wir setzen ihn um." },
  { q: "Wen sprechen Sie an?", why: "Nahe Angehörige, weiter Freundeskreis, Kolleginnen — der Kreis bestimmt die Sprache." },
  { q: "Wie lang darf sie sein?", why: "Kurz, mittel oder ausführlich — eine Rede darf niemals länger sein, als sie tragen kann." },
];

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für die Mutter?",
    a: "Nicht mit einer Aufzählung — mit einem Bild. Der Küchentisch am Sonntag, das Lied, das sie summte, ein Satz, den sie oft sagte. Von dort aus öffnet sich die Rede in warme, ruhige Sätze. Unser Fragebogen führt Sie in acht Schritten dorthin.",
  },
  {
    q: "Was, wenn viel unausgesprochen geblieben ist?",
    a: "Eine Trauerrede darf leise Räume lassen. Was nicht mehr gesagt werden konnte, kann jetzt in einem Satz gewürdigt werden — behutsam, ohne Schuld. Wir helfen, diese Balance zu finden.",
  },
  {
    q: "Wie persönlich darf eine Trauerrede für eine Frau werden?",
    a: "So persönlich, wie es ihr entsprochen hätte. Eine Anekdote, ein Kosename, ein leises Detail — genau das macht den Unterschied zwischen einer Rede und einer Würdigung.",
  },
  {
    q: "Können wir Zitate oder Lieder einfügen?",
    a: "Ja. Sie können im Fragebogen einen Vers, ein Zitat oder einen Liedausschnitt hinterlegen — wir binden ihn behutsam in den Entwurf ein, ohne den Fluss zu brechen.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für einen Mann", to: "/trauerrede-mann" },
  { label: "Trauerrede für den Ehepartner", to: "/trauerrede-ehepartner" },
];

export default function TrauerredeFrau() {
  return (
    <PersonaPage
      slug="trauerrede-frau"
      metaTitle="Trauerrede für eine Frau schreiben — Mutter, Schwester, Großmutter | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für die Mutter, Schwester, Großmutter oder Freundin. Warme, würdevolle Worte aus Ihren Erinnerungen — sofort verfügbar. Ab 29 €."
      eyebrow="Trauerrede · Mutter · Schwester · Großmutter · Freundin"
      headline={
        <>
          Eine Trauerrede für sie.
          <br />
          <span className="italic text-umber">Warm. Genau. In ihrer Stimme.</span>
        </>
      }
      intro="Für die Mutter, deren Küche der Mittelpunkt war. Für die Schwester, die einem alles zutraute. Für die Großmutter, deren Lieder man nie vergisst. Ein behutsamer erster Entwurf — aus acht ruhigen Fragen und Ihren Erinnerungen."
      heroImage="https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=1920&q=80"
      heroImageAlt="Ein Strauß Wiesenblumen auf einem hölzernen Küchentisch im warmen Licht — Sinnbild einer Trauerrede für eine Mutter oder Großmutter"
      questions={questions}
      exampleQuote={
        <>
          „Sie hatte eine Art, den Tag zu beginnen: erst das Fenster auf, dann das Wasser für den Tee.
          Wer sie hörte, wusste, dass das Haus atmet. Und wer sich zu ihr an den Tisch setzte, wusste
          nach fünf Minuten, dass hier zugehört wurde — nicht mit Ratschlägen, sondern mit einem Blick,
          der sagte: Ich bin hier.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
